import React from "react";
import { Box, Typography } from "@mui/material";
import { BankData } from "./types";

export const BankRow = ({ bank }: { bank?: BankData }) => {
  if (!bank) return <></>;
  return (
    <Box display="flex" alignItems="center" gap={3}>
      <Box display="flex">{bank.icon}</Box>
      <Typography variant="body3">{bank.name}</Typography>
    </Box>
  );
};
